export class User {
    public static PASSWORD_MIN_LENGTH = 6;
    public static PASSWORD_MAX_LENGTH = 100;
    public static EMAIL_MIN_LENGTH = 5;
    public static EMAIL_MAX_LENGTH = 100;
    public static LOGIN_MIN_LENGTH = 1;
    public static LOGIN_MAX_LENGTH = 50;
    public static LOGIN_PATTERN = '^[_\'.@A-Za-z0-9-]*$';
    public static NAME_MIN_LENGTH = 1;
    public static NAME_MAX_LENGTH = 50;

    public id?: any;
    public login?: string;
    public firstName?: string;
    public lastName?: string;
    public email?: string;
    public activated?: boolean;
    public langKey?: string;
    public authorities?: any[];
    public createdBy?: string;
    public createdDate?: Date;
    public lastModifiedBy?: string;
    public lastModifiedDate?: Date;
    public password?: string;
    public faculties?: number[];

    constructor(id?: any,
                login?: string,
                firstName?: string,
                lastName?: string,
                email?: string,
                activated?: boolean,
                langKey?: string,
                authorities?: any[],
                createdBy?: string,
                createdDate?: Date,
                lastModifiedBy?: string,
                lastModifiedDate?: Date,
                password?: string,
                faculties?: number[]) {
        this.id = id ? id : null;
        this.login = login ? login : null;
        this.firstName = firstName ? firstName : null;
        this.lastName = lastName ? lastName : null;
        this.email = email ? email : null;
        this.activated = activated ? activated : false;
        this.langKey = langKey ? langKey : null;
        this.authorities = authorities ? authorities : null;
        this.createdBy = createdBy ? createdBy : null;
        this.createdDate = createdDate ? createdDate : null;
        this.lastModifiedBy = lastModifiedBy ? lastModifiedBy : null;
        this.lastModifiedDate = lastModifiedDate ? lastModifiedDate : null;
        this.password = password ? password : null;
        this.faculties = faculties ? faculties : [];
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/models/user.model.ts